export const listTableOption = {
  // 帖子列表信息
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: '内容预览',
    width: 260,
    prop: 'title',
    overHidden: true,
    solt: true,
    align: 'left'
  }, {
    label: '链接',
    width: 260,
    prop: 'link',
    overHidden: true,
    solt: true,
    align: 'left'
  }, {
    label: '分类',
    prop: 'parentTags',
    overHidden: true,
    solt: true,
    align: 'left',
    width: 120,
  }, {
    label: '话题',
    prop: 'tags',
    align: 'left',
    overHidden: true,
    solt: true,
    width: 120,
  }, {
    label: '发布者',
    width: 160,
    prop: 'postedByName',
    align: 'left'
  }, {
    label: '内容类别',
    width: 80,
    prop: 'postType',
    align: 'left',
  },  {
    label: '发布时间',
    prop: 'postTime',
    sortable: true,
    align: 'left',
    width: 160,
  }, {
    label: '是否已下架',
    prop: 'isNotBanned',
    align: 'left',
    width: 110,
  }]
}
